import styled from 'styled-components'

/**
 * Inline "Learn how to…" help link used across the Device Access Control page
 * headers and cards: primary-coloured and underlined, with room for a trailing
 * external-link icon (render one as a child).
 */
export const HelpTextLink = styled.a`
  color: ${({ theme }) => theme.color.status.primary};
  text-decoration: underline;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:hover {
    color: ${({ theme }) => theme.color.hover.primary};
  }
`
